import { throttle } from "lodash";

export default class TopPersonalization {
    constructor(element) {
        
        var self = this;
       
        // Hide the Offie 365 bar on mobile devices.
        setTimeout(function () { self.toggleO365Bar(); }, 300);
        
        // When the browser is resized
        window.addEventListener("resize", throttle(self.toggleO365Bar, 300));
    }

    toggleO365Bar() {

        const personalizationBar = document.getElementById("top-personalization");
        const megaMenu = document.querySelectorAll("[data-module='megamenu']");
        const topSiteSection = document.querySelector(".topsite-section");

        const hideClass = "vgr-hidden";
        if (megaMenu[0].getAttribute("data-display-mode") === "mobile") {
            if (!personalizationBar.classList.contains(hideClass))
                personalizationBar.classList.add(hideClass);

            if (topSiteSection.classList.contains(hideClass))
                topSiteSection.classList.remove(hideClass);
        }
        else {
            if (personalizationBar.classList.contains(hideClass))
                personalizationBar.classList.remove(hideClass);

            if (!topSiteSection.classList.contains(hideClass))
                topSiteSection.classList.add(hideClass);

        }
    }
}
